import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Form, Input, InputNumber } from "antd";
import styled, { css } from "styled-components";

export const ShelfSizeBlock = styled.div`
    background-color: ${({ theme }) => theme.primaryBackground};
    border-radius: 10px;
    margin-bottom: 8px;
    display: flex;
    padding: 20px 16px;
    gap: 8px;
    flex-direction: column;
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 20px;
    margin-top: auto;
`;

export const StyledFormItem = styled(Form.Item)`
    .ant-form-item-additional {
        min-height: 0 !important;
    }
`;

const inputStyles = css`
    height: 42px;
    width: 100%;

    .ant-input-number-input {
        height: 42px;
        line-height: 42px;
        text-align: center;
    }
`;

export const StyledInputString = styled(Input)`
    ${inputStyles}
`;

export const StyledInputNumber = styled(InputNumber)`
    ${inputStyles}
`;

export const StyledShelfRow = styled.div`
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr 30% 32px;
`;

export const StyledDeleteButton = styled(Button)`
    margin-top: 5px;
    color: ${({ theme }) => theme.dangerTypographyColor};

    svg {
        font-size: 20px;
    }
`;

export const StyledDeleteMenuRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme.dangerTypographyColor};
`;

export const StyledAddShelfButton = styled(Button)`
    background-color: ${({ theme }) => theme.additionalTypographyColor};
    cursor: pointer;
    position: absolute;
    right: 16px;
    bottom: 100px;
    width: 50px !important;
    height: 50px !important;
    color: ${({ theme }) => theme.colors.white};

    svg {
        font-size: 25px;
    }
`;

export const StyledExclamationCircleOutlined = styled(
    ExclamationCircleOutlined,
)`
    color: ${({ theme }) => theme.dangerTypographyColor};
    font-size: 20px;
`;
